module.exports = __webpack_public_path__ + "static/img/login-mobile.jpg";